"use strict";

export default {
  amountOfModuleOne: 0,
  amountOfModuleTwo: 0,
  amountOfModuleTwoOne: 0,
  amountOfModuleTwoTwoPercent: 0,
  amountOfModuleThree: 0,
  amountOfModuleFour: 0,
  amountOfModuleFive: 0,
  amountOfModuleSix: 0,
  amountOfConsumablesByMonth: {},
  amountOfEquipmentsByMonth: {},
  amountOfUniformsByMonth: 0,
  amountOfUtensilsByMonth: {},
  analyticalWorksheet:{},
  budget:{},
  budgetFinalized: false,
  hasChange: false,
}



// WEBPACK FOOTER //
// ./src/store/modules/budget/state.js